import { render, staticRenderFns } from "./WidgetTemplates.vue?vue&type=template&id=0b01e8f2&scoped=true"
import script from "./WidgetTemplates.vue?vue&type=script&lang=js"
export * from "./WidgetTemplates.vue?vue&type=script&lang=js"
import style0 from "./WidgetTemplates.vue?vue&type=style&index=0&id=0b01e8f2&prod&lang=scss&scoped=true"
import style1 from "./WidgetTemplates.vue?vue&type=style&index=1&id=0b01e8f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b01e8f2",
  null
  
)

export default component.exports